import React from 'react';
import { FormattedMessage } from 'react-intl';

function RadioField(props) {
  const { name, checkboxText, className, id, onChange, value, defaultChecked, isDisabled } = props;

  return (
    <div className={"custom-control custom-control-alternative custom-radio " + className}>
      <input
        className="custom-control-input"
        id={`checkbox-${name}` + (id ? `-${id}` : "")}
        type="radio"
        checked={defaultChecked === value}
        value={value}
        onChange={onChange}
        name={name}
        disabled={ isDisabled }
      />
      <label
        className="custom-control-label"
        htmlFor={`checkbox-${name}` + (id ? `-${id}` : "")}
      >
        <span className="text-muted">
          {checkboxText}
        </span>
      </label>
    </div>
  );
}

RadioField.defaultProps = {
  name: 'radio',
  checkboxText: <FormattedMessage id="fields.radio" />,
  className: '',
  value: false,
};

export { RadioField };
